export default {
    'add-new-exam': 'إضافة امتحان جديد',
    'edit-exam': 'تعديل امتحان'
}